<div class="min-h-screen flex flex-col bg-gray-50">
  <p-toast></p-toast>
  <app-auth-header></app-auth-header>

  <!-- Hero Section -->
  <div class="bg-gradient-to-br from-jamaica-green-600 to-jamaica-green-900 py-4">
    <div class="container mx-auto px-4 text-center">
      <h1 class="text-3xl font-bold mb-2 text-white">Verify Your Email</h1>
      <p class="text-lg text-white">
        We've sent a verification email to your inbox
      </p>
    </div>
  </div>

<div class="container mx-auto px-4 py-8 max-w-2xl">
  <div class="bg-white rounded-lg shadow-lg p-8">
    <div class="text-center mb-8">
      <i class="pi pi-envelope text-6xl text-green-600 mb-4"></i>
      <h2 class="text-2xl font-bold text-gray-800 mb-4">
        Check Your Email
      </h2>
      <p class="text-gray-700 mb-2">
        We've sent a verification link to:
      </p>
      <p class="text-lg font-semibold text-green-600 mb-4">
        {{ userEmail }}
      </p>
      <p class="text-gray-700 mb-4">
        Please click the link in the email to verify your account and continue.
      </p>
    </div>

    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
      <div class="flex">
        <div class="flex-shrink-0">
          <i class="pi pi-exclamation-triangle text-yellow-400"></i>
        </div>
        <div class="ml-3">
          <p class="text-sm text-yellow-700">
            <strong>Important:</strong> If you don't see the email in your inbox:
          </p>
          <ul class="list-disc list-inside text-sm text-yellow-700 mt-2">
            <li>Check your spam or junk folder</li>
            <li>Add <strong>wallstyardie.com</strong> to your safe sender list</li>
            <li>Wait a few minutes for the email to arrive</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <p-button
        label="Resend Verification Email"
        icon="pi pi-refresh"
        styleClass="w-full"
        severity="secondary"
        [loading]="isResending"
        [disabled]="isResending"
        (click)="resendVerificationEmail()"
      ></p-button>

      <p-button
        label="Back to Login"
        icon="pi pi-arrow-left"
        styleClass="w-full"
        [outlined]="true"
        (click)="goToLogin()"
      ></p-button>
    </div>

    <div class="mt-6 text-center text-sm text-gray-600">
      <p>
        Need help? Contact us at
        <a href="mailto:bossman@wallstyardie.com" class="text-green-600 hover:text-green-700">
          bossman@wallstyardie.com
        </a>
      </p>
    </div>
  </div>

  <app-auth-footer></app-auth-footer>
</div>
